import React, { PropsWithChildren } from "react";

import { Action } from "../../types/action.types";
import { ActionType } from "../../types/enums/actionType.enum";
import { PrefetchedData } from "../../types/prefetchedData.types";
import { AddToCartButton } from "./AddToCartButton/addToCartButton.container";
import { AdvisorButton } from "./AdvisorButton/advisorButton.container";

type ButtonCallToActionProps = PropsWithChildren<{
    action: Action;
    prefetchedData?: PrefetchedData;
}>;

const ButtonCallToAction = ({
    children,
    action,
    prefetchedData,
}: ButtonCallToActionProps) =>
    action.actionType === ActionType.ADD_TO_CART ? (
        <AddToCartButton
            addToCartItems={action.addToCartItems.map(addToCartItem => ({
                amount: addToCartItem.amount,
                sku: addToCartItem.sku,
                product: prefetchedData?.products?.find(
                    ({ sku }) => sku === addToCartItem.sku,
                ),
            }))}
        >
            {children}
        </AddToCartButton>
    ) : action.actionType === ActionType.ADVISOR ? (
        <AdvisorButton
            advisorId={action.advisorId}
            advisorType={action.advisorType}
        >
            {children}
        </AdvisorButton>
    ) : null;

export { ButtonCallToAction };
